import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { IOrderViewerMainStore } from '../../typing/stores';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';

interface IContactUsButton {
	orderId?: number;
	contactEmail?: string;
}

const ContactUsButton: React.FunctionComponent<IContactUsButton & IActionButtonCommonProps> = props => {
	const handler = () => {
		const params = new URLSearchParams();
		params.set('Subject', encodeURIComponent(`Question about order ${props.orderId}`));
		const url = `mailto:${props.contactEmail}?${decodeURIComponent(params.toString())}`;
		window.location.href = url;
	};

	return (
		<ActionButton
			label={localize('Contact us')}
			handler={handler}
			icon={Icons.ChatIcon}
			isPrimary={props.isPrimary}
			testId="contact-us-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	orderId: stores.orderViewerStore.viewModel.orderId,
	contactEmail: stores.orderViewerStore.viewModel.headerModel.contactEmail
}))(ContactUsButton);
